export const JOB_REMOVE_REQUEST = 'job/remove-request'
export const JOB_REMOVE_SUCCESS = 'job/remove-success'
export const JOB_REMOVE_FAILED = 'job/remove-failed'
